import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Case Studies | Canny';
const Description =
  'Hundreds of software teams trust Canny to inform their product decisions. Here are their stories.';
const Image = 'https://canny.io/images/customers-helmet.png';

export default class CaseStudiesLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
